import React from 'react'
import BudgetsAllBudgets from 'src/app/BudgetsAllBudgets/BudgetsAllBudgets'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletBudgetsRouteProps } from 'src/navigation/routeProps'

const MyWalletBudgetsAppRoute: AppRoute = {
  id: AppLocation.MyWalletBudgets,
  routeProps: myWalletBudgetsRouteProps,
  component: <BudgetsAllBudgets />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletBudgetsAppRoute
